import { useState } from "react";
import { FiSearch } from "react-icons/fi";
import { GenreModel } from "../_types/genre-model";
import { Sort } from "../_types/sort";

const FilterBar = ({
	showSearch = true,
	showSort = true,
	showGenre = true,
	searchTerm,
	setSearchTerm,
	initialSorts = [],
	initialGenres = [],
	setSort,
	setGenre,
	activeGenre,
	activeSort,
}: {
	showSearch: boolean;
	showSort: boolean;
	showGenre: boolean;
	searchTerm?: string;
	setSearchTerm?: any;
	initialSorts?: any[];
	initialGenres?: any[];
	activeSort?: Sort;
	activeGenre?: GenreModel;
	setSort?: any;
	setGenre?: any;
}) => {
	const [selectedSort, setSelectedSort] = useState<null | { name: string }>(
		activeSort ?? null
	);
	const [selectedGenre, setSelectedGenre] = useState<null | GenreModel>(
		activeGenre ?? null
	);

	return (
		<div className="flex flex-wrap items-center gap-4 w-full md:w-auto">
			{showSearch && (
				<div className="relative w-full md:w-[400px] sm:w-[300px]">
					<input
						type="text"
						placeholder="جستجو..."
						className="w-full pl-4 pr-10 py-3 bg-[#1f1925] h-[50px] text-white rounded-md placeholder-gray-500 outline-none"
						value={searchTerm}
						onChange={(e) => setSearchTerm(e.target.value)}
					/>
					<button className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400">
						<FiSearch size={24} />
					</button>
				</div>
			)}

			{showSort && (
				<div className="relative w-full sm:w-[180px] min-w-max">
					<label className="absolute right-4 top-[15px] text-gray-400 text-[14px]">
						مرتب سازی
					</label>
					<select
						className="w-full bg-[#1f1925] px-4 py-3 rounded-md text-white text-[16px] cursor-pointer outline-none pr-[80px]"
						value={selectedSort && selectedSort.name ? selectedSort.name : ""}
						onChange={(e) => {
							if (!e.target.value) {
								setSelectedSort(null);
								setSort && setSort(null);
							}
							const foundSort = initialSorts.find(
								(sort) => sort.name === e.target.value
							);
							if (foundSort) {
								setSelectedSort(foundSort);
								setSort && setSort(foundSort);
							}
						}}
					>
						<option value="">پیشفرض</option>
						{initialSorts.map((sort) => (
							<option key={sort.name} value={sort.name}>
								{sort.name}
							</option>
						))}
					</select>
				</div>
			)}

			{showGenre && (
				<div className="relative w-full sm:w-[160px]">
					<label className="absolute right-4 top-[14px] text-gray-400 text-[14px]">
						ژانر
					</label>
					<select
						className="w-full bg-[#1f1925] px-4 py-3 rounded-md text-white text-[16px] cursor-pointer outline-none pr-[60px]"
						value={selectedGenre && selectedGenre.id ? selectedGenre.id : ""}
						onChange={(e) => {
							if (!e.target.value) {
								setSelectedGenre(null);
								setGenre && setGenre(null);
							}
							const foundGenre = initialGenres.find(
								(genre) => genre.id === e.target.value
							);
							if (foundGenre) {
								setSelectedGenre(foundGenre);
								setGenre && setGenre(foundGenre);
							}
						}}
					>
						<option value="">پیشفرض</option>
						{initialGenres.map((genre: GenreModel) => (
							<option key={genre.id} value={genre.id}>
								{genre.persianName}
							</option>
						))}
					</select>
				</div>
			)}
		</div>
	);
};

export default FilterBar;
